function isNumeric(value: string): boolean {
  return /^\d+(\.\d+)?$/.test(value);
}

export const trimNumber = (
  value: string | number | undefined,
): number | string => {
  if (value === undefined) {
    return '';
  }

  if (typeof value === 'string' && !isNumeric(value)) {
    return value;
  }

  return typeof value === 'string' ? parseFloat(value).toString() : value;
};
